const ppFavoriteStorageKey = 'pinperfect-favorites-v1';

function ppReadFavorites() {
  try {
    const saved = JSON.parse(localStorage.getItem(ppFavoriteStorageKey) || '[]');
    return Array.isArray(saved) ? saved.filter(item => /^\d+$/.test(String(item.id)) && typeof item.handle === 'string' && item.handle.length && !/[/?#]/.test(item.handle)).slice(0, 100) : [];
  } catch { return []; }
}

function ppToggleFavorite(id, handle) {
  const saved = ppReadFavorites();
  const exists = saved.some(item => String(item.id) === String(id));
  if (!exists && (saved.length >= 100 || !/^\d+$/.test(String(id)) || typeof handle !== 'string' || !handle.length || /[/?#]/.test(handle))) throw new Error();
  const next = exists ? saved.filter(item => String(item.id) !== String(id)) : [...saved, { id: String(id), handle }];
  localStorage.setItem(ppFavoriteStorageKey, JSON.stringify(next));
  window.dispatchEvent(new Event('pp:favorites-change'));
  return !exists;
}

customElements.define('pp-favorite-button', class extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-pp-save]');
    if (!this.button) return;
    this.saveLabel ||= this.button.getAttribute('aria-label');
    this.label = this.querySelector('[data-pp-save-label]');
    this.status = this.querySelector('[data-pp-favorite-status]');
    this.onSync = event => {
      if (event.type !== 'storage' || !event.key || event.key === ppFavoriteStorageKey) this.sync();
    };
    this.onClick = event => {
      if (!event.target.closest('[data-pp-save]')) return;
      event.preventDefault();
      event.stopPropagation();
      try {
        const saved = ppToggleFavorite(this.button.dataset.variant, this.button.dataset.handle);
        this.status.textContent = saved ? this.button.dataset.messageSaved : this.button.dataset.messageRemoved;
      } catch { this.status.textContent = this.button.dataset.messageError; }
    };
    this.onVariantChange = event => {
      if (event.target.name === 'id' && event.target.form?.getAttribute('id') === this.dataset.productForm) this.setVariant(event.target.value);
    };
    this.addEventListener('click', this.onClick);
    window.addEventListener('storage', this.onSync);
    window.addEventListener('pp:favorites-change', this.onSync);
    if (this.dataset.productForm) {
      document.addEventListener('change', this.onVariantChange);
      const variant = document.getElementById(this.dataset.productForm)?.querySelector('[name="id"]');
      if (variant) this.button.dataset.variant = variant.value;
    }
    this.sync();
  }

  setVariant(id) {
    this.button.dataset.variant = String(id || '');
    this.sync();
  }

  sync() {
    const saved = ppReadFavorites().some(item => String(item.id) === this.button.dataset.variant);
    this.button.disabled = !/^\d+$/.test(this.button.dataset.variant || '');
    this.button.setAttribute('aria-pressed', String(saved));
    this.button.setAttribute('aria-label', saved ? this.button.dataset.labelRemove : this.saveLabel);
    this.label.textContent = saved ? this.button.dataset.labelSaved : this.button.dataset.labelSave;
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('storage', this.onSync);
    window.removeEventListener('pp:favorites-change', this.onSync);
    document.removeEventListener('change', this.onVariantChange);
  }
});

customElements.define('pp-cart-panel', class extends HTMLElement {
  connectedCallback() {
    this.drawer = this.closest('cart-drawer');
    this.strings = JSON.parse(this.querySelector('[data-pp-cart-strings]').textContent);
    this.onClick = this.handleClick.bind(this);
    this.onSubmit = this.handleSubmit.bind(this);
    this.onOpen = this.loadSuggestions.bind(this);
    this.onStorage = event => {
      if (event.type === 'storage' && event.key && event.key !== ppFavoriteStorageKey) return;
      this.syncFavorites();
      if (!this.querySelector('#pp-saved-panel').hidden) this.loadFavorites();
    };
    this.onKey = (event) => {
      if (!event.target.matches('[data-pp-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = [...this.querySelectorAll('[data-pp-tab]')];
      const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[1] : tabs.find(tab => tab !== event.target);
      this.selectTab(next.dataset.ppTab);
      next.focus();
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('submit', this.onSubmit);
    this.addEventListener('keydown', this.onKey);
    this.drawer.addEventListener('pp:cart-open', this.onOpen);
    window.addEventListener('storage', this.onStorage);
    window.addEventListener('pp:favorites-change', this.onStorage);
    this.syncFavorites();
    if (this.drawer.classList.contains('active')) this.loadSuggestions();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('keydown', this.onKey);
    this.drawer.removeEventListener('pp:cart-open', this.onOpen);
    window.removeEventListener('storage', this.onStorage);
    window.removeEventListener('pp:favorites-change', this.onStorage);
  }

  favorites() {
    return ppReadFavorites();
  }

  syncFavorites() {
    const saved = this.favorites();
    this.querySelector('[data-pp-saved-count]').textContent = `(${saved.length})`;
    this.querySelectorAll('[data-pp-save]').forEach(button => {
      button.setAttribute('aria-pressed', String(saved.some(item => String(item.id) === button.dataset.variant)));
    });
  }

  status(message, discount = false) {
    const panel = this.drawer.querySelector('pp-cart-panel');
    const output = panel?.querySelector(discount ? '[data-pp-discount-status]' : '[data-pp-status]');
    if (output) { output.textContent = message; output.focus({ preventScroll: true }); }
  }

  selectTab(name) {
    this.querySelectorAll('[data-pp-tab]').forEach(tab => {
      const selected = tab.dataset.ppTab === name;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    this.querySelector('#pp-bag-panel').hidden = name !== 'bag';
    this.querySelector('#pp-saved-panel').hidden = name !== 'saved';
    this.querySelector('[data-pp-checkout]').hidden = name !== 'bag';
    this.querySelector('[data-pp-status]').textContent = '';
    if (name === 'saved') this.loadFavorites();
  }

  async handleClick(event) {
    const tab = event.target.closest('[data-pp-tab]');
    if (tab) return this.selectTab(tab.dataset.ppTab);
    const save = event.target.closest('[data-pp-save], [data-pp-remove-saved]');
    if (save) {
      try {
        const saved = ppToggleFavorite(save.dataset.variant, save.dataset.handle);
        return this.status(saved ? this.strings.saved : this.strings.unsaved);
      } catch { return this.status(this.strings.storage_error); }
    }
    const add = event.target.closest('[data-pp-add]');
    if (add) await this.mutate(routes.cart_add_url, { items: [{ id: add.dataset.ppAdd, quantity: 1 }] }, false);
    if (event.target.closest('[data-pp-clear-discounts]')) await this.mutate(routes.cart_update_url, { discount: '' }, true);
  }

  async handleSubmit(event) {
    if (!event.target.matches('[data-pp-discount]')) return;
    event.preventDefault();
    const code = new FormData(event.target).get('discount').trim();
    if (!code) return;
    await this.mutate(routes.cart_update_url, { discount: code }, true);
  }

  async mutate(url, body, discount) {
    if (this.drawer.hasAttribute('data-pp-busy') || this.querySelector('.cart__items--disabled')) return;
    this.drawer.setAttribute('data-pp-busy', '');
    this.setAttribute('aria-busy', 'true');
    const clearing = discount && body.discount === '';
    try {
      if (discount && !clearing) {
        const existingResponse = await fetch(`${routes.cart_url}.js`);
        if (!existingResponse.ok) throw new Error(this.strings.error);
        const existing = await existingResponse.json();
        const codes = (existing.discount_codes || []).filter(item => item.applicable).map(item => item.code);
        body.discount = [...new Set([...codes, body.discount])].join(',');
      }
      const response = await fetch(url.endsWith('.js') ? url : `${url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ...body, sections: this.drawer.getSectionsToRender().map(section => section.id), sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.status || cart.errors) throw new Error(cart.description || this.strings.error);
      if (cart.sections?.['cart-drawer']) this.drawer.renderContents(cart);
      else { location.assign(routes.cart_url); return; }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
      let message = this.strings.added;
      if (discount) {
        const code = body.discount.split(',').pop();
        const applied = cart.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
        message = clearing ? this.strings.discount_cleared : applied ? this.strings.discount_success : this.strings.discount_invalid;
      }
      this.status(message, discount);
    } catch (error) { this.status(error instanceof SyntaxError ? this.strings.error : error.message || this.strings.error, discount); }
    finally {
      this.drawer.removeAttribute('data-pp-busy');
      this.removeAttribute('aria-busy');
    }
  }

  async loadSuggestions() {
    const slot = this.querySelector('[data-pp-suggestions]');
    if (slot.dataset.loaded) return;
    slot.dataset.loaded = 'true';
    try {
      const url = new URL(location.href);
      url.searchParams.set('section_id', 'pp-cart-recommendations');
      const response = await fetch(url);
      if (!response.ok) throw new Error();
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-pp-recommendation-content]');
      if (content?.querySelector('article') && this.isConnected) { slot.replaceChildren(content); slot.hidden = false; }
    } catch { delete slot.dataset.loaded; }
  }

  async loadFavorites() {
    const list = this.querySelector('[data-pp-saved-list]');
    const saved = this.favorites();
    const request = Symbol();
    this.favoritesRequest = request;
    list.textContent = saved.length ? this.strings.loading : this.strings.saved_empty;
    const results = await Promise.allSettled(saved.map(async item => {
      const response = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`);
      if (!response.ok) throw new Error();
      return { item, product: await response.json() };
    }));
    if (!this.isConnected || this.favoritesRequest !== request || !saved.length) return;
    list.replaceChildren();
    let failed = false;
    results.forEach((result, index) => {
      const { item, product } = result.status === 'fulfilled' ? result.value : { item: saved[index] };
      if (!product) failed = true;
      const variant = product?.variants.find(variant => String(variant.id) === String(item.id));
      const card = document.createElement('article');
      card.className = 'pp-cart-favorite';
      const link = document.createElement('a');
      link.href = `${window.Shopify.routes.root}products/${item.handle}?variant=${item.id}`;
      link.textContent = product?.title || this.strings.view_product;
      const details = document.createElement('div');
      details.append(link);
      if (variant) {
        const price = document.createElement('p');
        price.textContent = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100);
        details.append(price);
        const estimate = document.createElement('pp-converted-price');
        estimate.setAttribute('data-ils-cents', String(variant.price));
        estimate.hidden = true;
        details.append(estimate);
      }
      const favoriteImage = variant?.featured_image?.src || product?.featured_image;
      if (favoriteImage) {
        const image = document.createElement('img');
        const source = new URL(favoriteImage, location.origin);
        source.searchParams.set('width', '180');
        image.src = source.href;
        image.alt = '';
        image.width = 72; image.height = 72; image.loading = 'lazy';
        card.append(image);
      }
      const add = document.createElement('button');
      add.type = 'button'; add.className = 'pp-cart-add';
      const simple = product?.variants.length === 1 && !product.requires_selling_plan && !product.selling_plan_groups?.length;
      if (simple && variant?.available && (!variant.quantity_rule || variant.quantity_rule.min === 1 && variant.quantity_rule.increment === 1)) {
        add.dataset.ppAdd = item.id; add.textContent = this.strings.add; details.append(add);
      } else if (variant && !variant.available) {
        add.disabled = true; add.textContent = this.strings.sold_out; details.append(add);
      }
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'link pp-cart-remove-favorite';
      remove.dataset.ppRemoveSaved = ''; remove.dataset.variant = item.id;
      remove.textContent = this.strings.remove_favorite;
      details.append(remove); card.append(details); list.append(card);
    });
    if (failed) this.status(this.strings.load_error);
  }
});
